const injectScriptInNode = (element, url) => {
  const script = document.createElement('script')
  script.setAttribute('type', 'text/javascript')
  script.setAttribute('src', url)
  script.async = true

  element?.appendChild(script)
}

export default injectScriptInNode
